/**
 * Contact color mapping utility
 * Maps contact IDs to distinct colors for visual identification
 * Maximum of 4 colors supported
 */

export const CONTACT_COLORS = [
  '#D4E157', // Lime (Yellow-Green)
  '#F48FB1', // Light Pink
  '#81C784', // Light Green
  '#64B5F6', // Light Blue
];

/**
 * Creates a mapping of contact IDs to colors
 * @param contactIds - Array of contact IDs
 * @returns Record mapping contact ID to color hex code
 */
export function createContactColorMap(contactIds: number[]): Record<number, string> {
  // Sort contact IDs to ensure consistent color assignment
  const uniqueIds = Array.from(new Set(contactIds)).sort((a, b) => a - b);
  const colorMap: Record<number, string> = {};

  uniqueIds.forEach((id, index) => {
    if (index < CONTACT_COLORS.length) {
      colorMap[id] = CONTACT_COLORS[index];
    }
  });

  return colorMap;
}
